import { render, staticRenderFns } from "./LivestreamAssignRole.vue?vue&type=template&id=8bd85bc8&scoped=true"
import script from "./LivestreamAssignRole.vue?vue&type=script&lang=js"
export * from "./LivestreamAssignRole.vue?vue&type=script&lang=js"
import style0 from "./LivestreamAssignRole.vue?vue&type=style&index=0&id=8bd85bc8&prod&scoped=true&lang=scss"
import style1 from "./LivestreamAssignRole.vue?vue&type=style&index=1&id=8bd85bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd85bc8",
  null
  
)

export default component.exports